import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { hideModal } from "../../data/modal";
import GetContactOptions from '../FormHelpers/ContactSelectOptions';
import { SelectField } from '../FormFields/RenderSelectField';
import { Button, Grid } from "@mui/material";
import {
  Close as CloseIcon,
} from "@mui/icons-material";

const TerminalCallMailerForm = ({
  mailPlanning,
  contacts
}) => {
  const dispatch = useDispatch()

  const { handleSubmit, control, formState } = useForm({
    defaultValues: {
      contact: contacts[0]['@id'] ?? null,
    }
  });

  const { isSubmitting } = formState;

  const onSubmit = (data) => {
    mailPlanning(data)
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Grid item xs={12}>
            <Grid
              item
              xs={12}
              className="form-fields-container"
              ml={4}
              mt={4}
            >
              <Grid item xs={12} sm={8}>
                <SelectField
                  name='contact'
                  label='Contact'
                  control={control}
                  options={GetContactOptions(contacts)}
                  defaultValue={GetContactOptions(contacts) ? GetContactOptions(contacts)[0] : null}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className="button-wrapper" mt={2}>
        <Button
          onClick={() => {
            dispatch(hideModal());
          }}
          variant="contained"
          size="small"
        >
          <CloseIcon fontSize="inherit" />
          &nbsp;Close
        </Button>
        <Button
          type="submit"
          disabled={isSubmitting}
          variant="contained"
          size="small"
          sx={{ ml: 1 }}
        >
          Mail planning
        </Button>
      </Grid>
    </form>
  );
};

export default TerminalCallMailerForm;